<template>
    <div class="public-offer-auth">
        <DefaultAuthModal
            :additional-fields="{ order_id: orderId }"
            :login-action="loginAction"
            :visible="true"
            :flat="true"
        />
    </div>
</template>

<script>
import DefaultAuthModal from "@public-modal/view/DefaultAuthModal"

export default {
    props: {
        orderId: {
            type: [Number, String],
            default: 0
        }
    },
    name: "PublicOfferAuth",
    components: { DefaultAuthModal },
    methods: {
        loginAction({ token }) {
            if (token) {
                this.$emit("auth", token)
            }
        }
    }
}
</script>
